import Vue from 'vue'
import App from './index.vue'
import store from '../store'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../static/css/base.less'
import '../static/css/lexus-font.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.config.productionTip = false
import registerServiceWorker from '../sw'

const mountApp = () => {
    new Vue({
        store,
        render: h => h(App)
    }).$mount('#app')
}

registerServiceWorker().then(mountApp, mountApp)
